// i18n for RE₿EL Governance / DAO (ES / EN / SK).
export const GOVERNANCE_I18N = {
  es: {
    title: "Gobernanza RE₿EL",
    subtitle: "Vota el futuro del ecosistema con tu R₿L",
    heroText:
      "1 R₿L = 1 voto. Los holders deciden qué cursos añadir, cómo evolucionan el Vault y el burning, y hacia dónde va la plataforma. Los votos son gratuitos — solo firmas con tu wallet, sin gas. Los resultados son vinculantes para el desarrollo de RE₿EL.",
    yourVotingPower: "Tu poder de voto",
    votes: "votos",
    ofSupply: "del supply",
    activeProposals: "Propuestas activas",
    pastProposals: "Propuestas pasadas",
    createProposal: "Crear propuesta",
    vote: "Votar",
    yes: "A favor",
    no: "En contra",
    passed: "Aprobada",
    rejected: "Rechazada",
    active: "Activa",
    implemented: "Implementada",
    official: "Oficial",
    closesIn: "Cierra en",
    closed: "Cerrada",
    quorum: "Quórum",
    quorumMet: "Quórum alcanzado",
    quorumNotMet: "Quórum no alcanzado",
    participation: "Participación media",
    minBalanceVote: "Necesitas 10,000 R₿L para votar",
    minBalancePropose: "Necesitas 500,000 R₿L para proponer",
    alreadyVoted: "Ya has votado",
    yourVote: "Tu voto",
    yourPowerUsed: "Poder usado",
    connectToVote: "Conecta tu wallet para votar",
    connectWallet: "Conectar wallet",
    selectWallet: "Selecciona tu wallet",
    disconnect: "Desconectar wallet",
    wrongNet: "Cambia a Base L2",
    switchBase: "Cambiar a Base",
    proposalType: "Tipo de propuesta",
    duration: "Duración de votación",
    days: "días",
    proposedBy: "Propuesto por",
    team: "Equipo RE₿EL",
    viewDetails: "Ver detalles",
    recentVoters: "Últimos votantes",
    noVotersYet: "Aún no hay votos — sé el primero",
    totalProposals: "Propuestas totales",
    approvedCount: "Aprobadas",
    totalVotesCast: "R₿L en votos",
    statsTitle: "Estadísticas",
    formTitle: "Título",
    formTitlePh: "Título de la propuesta (máx 100 caracteres)",
    formDescription: "Descripción",
    formDescriptionPh:
      "Contexto, motivación y detalle de la propuesta (markdown básico, máx 2000 caracteres)",
    preview: "Vista previa",
    edit: "Editar",
    signAndPublish: "Firmar y publicar",
    signingWallet: "Firma en tu wallet…",
    publishing: "Publicando…",
    proposalCreated: "¡Propuesta publicada!",
    voteRegistered: "¡Voto registrado!",
    votingAs: "Votando como",
    snapshotNote: "El poder de voto usa tu balance R₿L del snapshot de la propuesta (anti-manipulación).",
    freeVoteNote: "Votar es gratis — solo firma EIP-712, sin gas.",
    noActive: "No hay propuestas activas ahora mismo",
    noPast: "Aún no hay propuestas cerradas",
    error: "Error",
    retry: "Reintentar",
    cancel: "Cancelar",
    loginFirst: "Inicia sesión para participar",
    howItWorks: "Cómo funciona",
    rule1: "Votar: balance ≥ 10,000 R₿L · 1 R₿L = 1 voto",
    rule2: "Proponer: balance ≥ 500,000 R₿L",
    rule3: "Quórum: 10,000,000 R₿L (1% del supply) · mayoría >50%",
    rule4: "Snapshot del balance al crear la propuesta — sin gas, solo firma",
    type_course_add: "Añadir curso",
    type_course_remove: "Eliminar curso",
    type_feature_request: "Nueva funcionalidad",
    type_vault_params: "Parámetros del Vault",
    type_burn_rate: "Tasa de burning",
    type_mentor_admit: "Admitir mentor",
    type_partnership: "Partnership",
    type_treasury: "Treasury",
    type_other: "Otra",
    err_insufficient_balance: "Balance R₿L insuficiente",
    err_already_voted: "Ya has votado en esta propuesta",
    err_proposal_closed: "La propuesta ya está cerrada",
    err_invalid_signature: "Firma inválida",
    err_signature_expired: "Firma caducada — reintenta",
  },
  en: {
    title: "RE₿EL Governance",
    subtitle: "Vote on the ecosystem future with your R₿L",
    heroText:
      "1 R₿L = 1 vote. Holders decide which courses to add, how the Vault and burning evolve, and where the platform goes. Voting is free — you just sign with your wallet, no gas. Results are binding for RE₿EL development.",
    yourVotingPower: "Your voting power",
    votes: "votes",
    ofSupply: "of supply",
    activeProposals: "Active proposals",
    pastProposals: "Past proposals",
    createProposal: "Create proposal",
    vote: "Vote",
    yes: "Yes",
    no: "No",
    passed: "Passed",
    rejected: "Rejected",
    active: "Active",
    implemented: "Implemented",
    official: "Official",
    closesIn: "Closes in",
    closed: "Closed",
    quorum: "Quorum",
    quorumMet: "Quorum reached",
    quorumNotMet: "Quorum not reached",
    participation: "Avg participation",
    minBalanceVote: "You need 10,000 R₿L to vote",
    minBalancePropose: "You need 500,000 R₿L to propose",
    alreadyVoted: "Already voted",
    yourVote: "Your vote",
    yourPowerUsed: "Power used",
    connectToVote: "Connect your wallet to vote",
    connectWallet: "Connect wallet",
    selectWallet: "Select your wallet",
    disconnect: "Disconnect wallet",
    wrongNet: "Switch to Base L2",
    switchBase: "Switch to Base",
    proposalType: "Proposal type",
    duration: "Voting duration",
    days: "days",
    proposedBy: "Proposed by",
    team: "RE₿EL Team",
    viewDetails: "View details",
    recentVoters: "Recent voters",
    noVotersYet: "No votes yet — be the first",
    totalProposals: "Total proposals",
    approvedCount: "Approved",
    totalVotesCast: "R₿L in votes",
    statsTitle: "Statistics",
    formTitle: "Title",
    formTitlePh: "Proposal title (max 100 chars)",
    formDescription: "Description",
    formDescriptionPh:
      "Context, motivation and detail of the proposal (basic markdown, max 2000 chars)",
    preview: "Preview",
    edit: "Edit",
    signAndPublish: "Sign & publish",
    signingWallet: "Sign in your wallet…",
    publishing: "Publishing…",
    proposalCreated: "Proposal published!",
    voteRegistered: "Vote registered!",
    votingAs: "Voting as",
    snapshotNote: "Voting power uses your R₿L balance at the proposal snapshot (anti-manipulation).",
    freeVoteNote: "Voting is free — EIP-712 signature only, no gas.",
    noActive: "No active proposals right now",
    noPast: "No closed proposals yet",
    error: "Error",
    retry: "Retry",
    cancel: "Cancel",
    loginFirst: "Log in to participate",
    howItWorks: "How it works",
    rule1: "Vote: balance ≥ 10,000 R₿L · 1 R₿L = 1 vote",
    rule2: "Propose: balance ≥ 500,000 R₿L",
    rule3: "Quorum: 10,000,000 R₿L (1% of supply) · majority >50%",
    rule4: "Balance snapshot at proposal creation — no gas, signature only",
    type_course_add: "Add course",
    type_course_remove: "Remove course",
    type_feature_request: "New feature",
    type_vault_params: "Vault parameters",
    type_burn_rate: "Burn rate",
    type_mentor_admit: "Admit mentor",
    type_partnership: "Partnership",
    type_treasury: "Treasury",
    type_other: "Other",
    err_insufficient_balance: "Insufficient R₿L balance",
    err_already_voted: "You already voted on this proposal",
    err_proposal_closed: "This proposal is already closed",
    err_invalid_signature: "Invalid signature",
    err_signature_expired: "Signature expired — retry",
  },
  sk: {
    title: "Správa RE₿EL",
    subtitle: "Hlasuj o budúcnosti ekosystému svojím R₿L",
    heroText:
      "1 R₿L = 1 hlas. Holderi rozhodujú, ktoré kurzy pridať, ako sa vyvíja Vault a burning a kam smeruje platforma. Hlasovanie je zadarmo — len podpíšeš peňaženkou, bez gas poplatkov. Výsledky sú záväzné pre vývoj RE₿EL.",
    yourVotingPower: "Tvoja hlasovacia sila",
    votes: "hlasov",
    ofSupply: "supply",
    activeProposals: "Aktívne návrhy",
    pastProposals: "Minulé návrhy",
    createProposal: "Vytvoriť návrh",
    vote: "Hlasovať",
    yes: "Za",
    no: "Proti",
    passed: "Schválený",
    rejected: "Zamietnutý",
    active: "Aktívny",
    implemented: "Implementovaný",
    official: "Oficiálny",
    closesIn: "Uzatvára sa o",
    closed: "Uzavretý",
    quorum: "Kvórum",
    quorumMet: "Kvórum dosiahnuté",
    quorumNotMet: "Kvórum nedosiahnuté",
    participation: "Priemerná účasť",
    minBalanceVote: "Potrebuješ 10 000 R₿L na hlasovanie",
    minBalancePropose: "Potrebuješ 500 000 R₿L na návrh",
    alreadyVoted: "Už si hlasoval",
    yourVote: "Tvoj hlas",
    yourPowerUsed: "Použitá sila",
    connectToVote: "Pripoj peňaženku na hlasovanie",
    connectWallet: "Pripojiť peňaženku",
    selectWallet: "Vyber peňaženku",
    disconnect: "Odpojiť peňaženku",
    wrongNet: "Prepni na Base L2",
    switchBase: "Prepnúť na Base",
    proposalType: "Typ návrhu",
    duration: "Trvanie hlasovania",
    days: "dní",
    proposedBy: "Navrhol",
    team: "Tím RE₿EL",
    viewDetails: "Zobraziť detaily",
    recentVoters: "Poslední hlasujúci",
    noVotersYet: "Zatiaľ žiadne hlasy — buď prvý",
    totalProposals: "Návrhy celkom",
    approvedCount: "Schválené",
    totalVotesCast: "R₿L v hlasoch",
    statsTitle: "Štatistiky",
    formTitle: "Názov",
    formTitlePh: "Názov návrhu (max 100 znakov)",
    formDescription: "Popis",
    formDescriptionPh:
      "Kontext, motivácia a detail návrhu (základný markdown, max 2000 znakov)",
    preview: "Náhľad",
    edit: "Upraviť",
    signAndPublish: "Podpísať a zverejniť",
    signingWallet: "Podpíš v peňaženke…",
    publishing: "Zverejňujem…",
    proposalCreated: "Návrh zverejnený!",
    voteRegistered: "Hlas zaregistrovaný!",
    votingAs: "Hlasuješ ako",
    snapshotNote: "Hlasovacia sila používa tvoj R₿L zostatok zo snapshot bloku návrhu (anti-manipulácia).",
    freeVoteNote: "Hlasovanie je zadarmo — len EIP-712 podpis, bez gas.",
    noActive: "Momentálne nie sú žiadne aktívne návrhy",
    noPast: "Zatiaľ žiadne uzavreté návrhy",
    error: "Chyba",
    retry: "Skúsiť znova",
    cancel: "Zrušiť",
    loginFirst: "Prihlás sa pre účasť",
    howItWorks: "Ako to funguje",
    rule1: "Hlasovanie: zostatok ≥ 10 000 R₿L · 1 R₿L = 1 hlas",
    rule2: "Návrh: zostatok ≥ 500 000 R₿L",
    rule3: "Kvórum: 10 000 000 R₿L (1 % supply) · väčšina >50 %",
    rule4: "Snapshot zostatku pri vytvorení návrhu — bez gas, len podpis",
    type_course_add: "Pridať kurz",
    type_course_remove: "Odstrániť kurz",
    type_feature_request: "Nová funkcia",
    type_vault_params: "Parametre Vaultu",
    type_burn_rate: "Miera burningu",
    type_mentor_admit: "Prijať mentora",
    type_partnership: "Partnerstvo",
    type_treasury: "Treasury",
    type_other: "Iné",
    err_insufficient_balance: "Nedostatočný R₿L zostatok",
    err_already_voted: "V tomto návrhu si už hlasoval",
    err_proposal_closed: "Tento návrh je už uzavretý",
    err_invalid_signature: "Neplatný podpis",
    err_signature_expired: "Podpis vypršal — skús znova",
  },
  "zh-CN": {
    title: "RE₿EL 治理",
    subtitle: "用你的 R₿L 投票决定生态系统的未来",
    heroText: "1 R₿L = 1 票。持有者决定添加哪些课程、Vault 和销毁机制如何演变，以及平台的发展方向。投票免费——只需用钱包签名，无需 gas。投票结果对 RE₿EL 的开发具有约束力。",
    yourVotingPower: "你的投票权",
    votes: "票",
    ofSupply: "占总供应量",
    activeProposals: "活跃提案",
    pastProposals: "历史提案",
    createProposal: "创建提案",
    vote: "投票",
    yes: "赞成",
    no: "反对",
    passed: "通过",
    rejected: "否决",
    active: "活跃",
    implemented: "已实施",
    official: "官方",
    closesIn: "距离结束",
    closed: "已结束",
    quorum: "法定人数",
    quorumMet: "达到法定人数",
    quorumNotMet: "未达到法定人数",
    participation: "平均参与度",
    minBalanceVote: "需要 10,000 R₿L 才能投票",
    minBalancePropose: "需要 500,000 R₿L 才能提案",
    alreadyVoted: "你已投票",
    yourVote: "你的投票",
    yourPowerUsed: "已使用投票权",
    connectToVote: "连接钱包以投票",
    connectWallet: "连接钱包",
    selectWallet: "选择你的钱包",
    disconnect: "断开钱包",
    wrongNet: "切换到 Base L2",
    switchBase: "切换到 Base",
    proposalType: "提案类型",
    duration: "投票时长",
    days: "天",
    proposedBy: "提案人",
    team: "RE₿EL 团队",
    viewDetails: "查看详情",
    recentVoters: "最近投票者",
    noVotersYet: "还没有投票——成为第一个",
    totalProposals: "提案总数",
    approvedCount: "已通过",
    totalVotesCast: "R₿L 投票数",
    statsTitle: "统计数据",
    formTitle: "标题",
    formTitlePh: "提案标题（最多 100 个字符）",
    formDescription: "描述",
    formDescriptionPh: "提案的背景、动机和详细信息（支持基本 markdown，最多 2000 个字符）",
    preview: "预览",
    edit: "编辑",
    signAndPublish: "签名并发布",
    signingWallet: "正在你的钱包中签名…",
    publishing: "正在发布…",
    proposalCreated: "提案已发布！",
    voteRegistered: "投票已登记！",
    votingAs: "以此身份投票",
    snapshotNote: "投票权基于提案快照时的 R₿L 余额（防操纵）。",
    freeVoteNote: "投票免费——仅需 EIP-712 签名，无需 gas。",
    noActive: "目前没有活跃提案",
    noPast: "还没有已结束的提案",
    error: "错误",
    retry: "重试",
    cancel: "取消",
    loginFirst: "登录以参与",
    howItWorks: "运作方式",
    rule1: "投票：余额 ≥ 10,000 R₿L · 1 R₿L = 1 票",
    rule2: "提案：余额 ≥ 500,000 R₿L",
    rule3: "法定人数：10,000,000 R₿L（占供应量 1%）· 多数票 >50%",
    rule4: "余额快照于创建提案时——无 gas，仅签名",
    type_course_add: "添加课程",
    type_course_remove: "删除课程",
    type_feature_request: "新功能",
    type_vault_params: "Vault 参数",
    type_burn_rate: "销毁率",
    type_mentor_admit: "接纳导师",
    type_partnership: "合作伙伴关系",
    type_treasury: "Treasury",
    type_other: "其他",
    err_insufficient_balance: "R₿L 余额不足",
    err_already_voted: "你已在此提案中投票",
    err_proposal_closed: "提案已结束",
    err_invalid_signature: "签名无效",
    err_signature_expired: "签名已过期——请重试",
  },
  de: {
    title: "RE₿EL Governance",
    subtitle: "Stimme über die Zukunft des Ökosystems mit deinem R₿L ab",
    heroText: "1 R₿L = 1 Stimme. Die Holder entscheiden, welche Kurse hinzugefügt werden, wie sich Vault und Burning weiterentwickeln und wohin sich die Plattform bewegt. Abstimmungen sind kostenlos — nur Signatur mit deiner Wallet, ohne Gas. Die Ergebnisse sind verbindlich für die Entwicklung von RE₿EL.",
    yourVotingPower: "Deine Stimmkraft",
    votes: "Stimmen",
    ofSupply: "vom Supply",
    activeProposals: "Aktive Vorschläge",
    pastProposals: "Vergangene Vorschläge",
    createProposal: "Vorschlag erstellen",
    vote: "Abstimmen",
    yes: "Dafür",
    no: "Dagegen",
    passed: "Angenommen",
    rejected: "Abgelehnt",
    active: "Aktiv",
    implemented: "Umgesetzt",
    official: "Offiziell",
    closesIn: "Schließt in",
    closed: "Geschlossen",
    quorum: "Quorum",
    quorumMet: "Quorum erreicht",
    quorumNotMet: "Quorum nicht erreicht",
    participation: "Durchschnittliche Beteiligung",
    minBalanceVote: "Du benötigst 10.000 R₿L zum Abstimmen",
    minBalancePropose: "Du benötigst 500.000 R₿L zum Vorschlagen",
    alreadyVoted: "Du hast bereits abgestimmt",
    yourVote: "Deine Stimme",
    yourPowerUsed: "Verwendete Stimmkraft",
    connectToVote: "Verbinde deine Wallet zum Abstimmen",
    connectWallet: "Wallet verbinden",
    selectWallet: "Wähle deine Wallet",
    disconnect: "Wallet trennen",
    wrongNet: "Wechsle zu Base L2",
    switchBase: "Zu Base wechseln",
    proposalType: "Vorschlagstyp",
    duration: "Abstimmungsdauer",
    days: "Tage",
    proposedBy: "Vorgeschlagen von",
    team: "RE₿EL Team",
    viewDetails: "Details anzeigen",
    recentVoters: "Letzte Abstimmende",
    noVotersYet: "Noch keine Stimmen — sei der Erste",
    totalProposals: "Vorschläge gesamt",
    approvedCount: "Angenommen",
    totalVotesCast: "R₿L in Stimmen",
    statsTitle: "Statistiken",
    formTitle: "Titel",
    formTitlePh: "Titel des Vorschlags (max. 100 Zeichen)",
    formDescription: "Beschreibung",
    formDescriptionPh: "Kontext, Motivation und Details des Vorschlags (einfaches Markdown, max. 2000 Zeichen)",
    preview: "Vorschau",
    edit: "Bearbeiten",
    signAndPublish: "Signieren und veröffentlichen",
    signingWallet: "Signiere in deiner Wallet…",
    publishing: "Veröffentlichen…",
    proposalCreated: "Vorschlag veröffentlicht!",
    voteRegistered: "Stimme registriert!",
    votingAs: "Abstimmend als",
    snapshotNote: "Die Stimmkraft verwendet dein R₿L-Guthaben vom Snapshot des Vorschlags (Anti-Manipulation).",
    freeVoteNote: "Abstimmen ist kostenlos — nur EIP-712-Signatur, kein Gas.",
    noActive: "Aktuell keine aktiven Vorschläge",
    noPast: "Noch keine geschlossenen Vorschläge",
    error: "Fehler",
    retry: "Erneut versuchen",
    cancel: "Abbrechen",
    loginFirst: "Melde dich an, um teilzunehmen",
    howItWorks: "So funktioniert's",
    rule1: "Abstimmen: Guthaben ≥ 10.000 R₿L · 1 R₿L = 1 Stimme",
    rule2: "Vorschlagen: Guthaben ≥ 500.000 R₿L",
    rule3: "Quorum: 10.000.000 R₿L (1% des Supply) · Mehrheit >50%",
    rule4: "Snapshot des Guthabens beim Erstellen des Vorschlags — kein Gas, nur Signatur",
    type_course_add: "Kurs hinzufügen",
    type_course_remove: "Kurs entfernen",
    type_feature_request: "Neue Funktionalität",
    type_vault_params: "Vault-Parameter",
    type_burn_rate: "Burning-Rate",
    type_mentor_admit: "Mentor zulassen",
    type_partnership: "Partnership",
    type_treasury: "Treasury",
    type_other: "Andere",
    err_insufficient_balance: "Unzureichendes R₿L-Guthaben",
    err_already_voted: "Du hast bereits bei diesem Vorschlag abgestimmt",
    err_proposal_closed: "Der Vorschlag ist bereits geschlossen",
    err_invalid_signature: "Ungültige Signatur",
    err_signature_expired: "Signatur abgelaufen — erneut versuchen",
  },
};

export const tGov = (lang, key) => {
  const dict = GOVERNANCE_I18N[lang] || GOVERNANCE_I18N.es;
  if (dict[key] !== undefined) return dict[key];
  return GOVERNANCE_I18N.es[key] !== undefined ? GOVERNANCE_I18N.es[key] : key;
};

export default GOVERNANCE_I18N;
